import { Attachment, Button, Checkbox, DataHeader, DataSource, DateRangeFilter, Image, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutWebControl extends Layout {
    attachmentOfferOrderLogo: Attachment;
    attachmentWaterfallLogo: Attachment;
    buttonOpenClassic: Button;
    checkboxMandatoryRatings: Checkbox;
    dataheaderTitle: DataHeader;
    daterangefilterCarrierStatistics: DateRangeFilter;
    image10: Image;
    image11: Image;
    image12: Image;
    image13: Image;
    image14: Image;
    image15: Image;
    image16: Image;
    image17: Image;
    image18: Image;
    image19: Image;
    image1: Image;
    image20: Image;
    image21: Image;
    image22: Image;
    image23: Image;
    image24: Image;
    image25: Image;
    image2: Image;
    image3: Image;
    image4: Image;
    image5: Image;
    image6: Image;
    image7: Image;
    image8: Image;
    image9: Image;
    imageMPactSmartTargetWarning: Image;
    labelAnd1: Label;
    labelAnd2: Label;
    labelAnd3: Label;
    labelAnd4: Label;
    labelAnd5: Label;
    labelCarrierRanking: Label;
    labelCreation: Label;
    labelLoadSearch: Label;
    panelCreation: Panel;
    panelLoadSearch: Panel;
    panelMaxPay: Panel;
    panelRanking1: Panel;
    panelRanking2: Panel;
    panelRanking3: Panel;
    panelRanking4: Panel;
    panelRanking5: Panel;
    panelScorecardLeft: Panel;
    panelScorecardRanking: Panel;
    sourceDispatchControl: DataSource;
    sourceRateExceptionDispatchControl: DataSource;
    switchAllowDispatchHazmatCertBlank: Switch;
    switchAllowDispatchHazmatExpBlank: Switch;
    switchAutoPayRates: Switch;
    switchBtmIncludePartial: Switch;
    switchCalculateBrokerageMargOnNet: Switch;
    switchCalculateFuelSurchrgePay: Switch;
    switchCreateCarrierCallin: Switch;
    switchDefaultExpiration: Switch;
    switchDisplayBtm: Switch;
    switchDisplayContinuousMovesOnOffers: Switch;
    switchDisplayContinuousMovesOnOffersWaterfall: Switch;
    switchEnableAuthorizedUserOverride: Switch;
    switchEnableAutoCreate: Switch;
    switchEnableCarrierAutoRating: Switch;
    switchEnforceBrokerageWorkflow: Switch;
    switchEnforceDepartureDates: Switch;
    switchEnforceMaxPay: Switch;
    switchEnforceTargetPay: Switch;
    switchIncludeInactivePNNCarriers: Switch;
    switchIncludeInactivePNNCarriersWaterfall: Switch;
    switchRequireUnassignmentReasons: Switch;
    switchSaveRateConfToOrderhist: Switch;
    switchUsePrimaryEquipment: Switch;
    tabAssignCarrier: Tab;
    tabBlastOffers: Tab;
    tabBrokerageOperations: Tab;
    tabBrokeragePlanning: Tab;
    tabBuyToMarket: Tab;
    tabCarrierCapacity: Tab;
    tabCarrierPay: Tab;
    tabCarrierPaySecondary: Tab;
    tabCarrierQualifications: Tab;
    tabCheckCalls: Tab;
    tabDispatch: Tab;
    tabElectronicOffers: Tab;
    tabMandatoryCarrierRatings: Tab;
    tabMultiSelect: Tab;
    tabRateConfirmation: Tab;
    tabTargetMaxPay: Tab;
    tabWaterfallTender: Tab;
    tabsetBrokeragePlanning: Tabset;
    tabsetCarrierPay: Tabset;
    tabsetControlGroups: Tabset;
    tabsetElectronicOffers: Tabset;
    textboxAutomaticStatus: Textbox;
    textboxAvailableOrderStatus: Textbox;
    textboxBrkQualProfile: Textbox;
    textboxBrokerageWorkflowId: Textbox;
    textboxBtmOrderType: Textbox;
    textboxBtmRevenueCode: Textbox;
    textboxBtmTrailerType: Textbox;
    textboxCheckCallWarning: Textbox;
    textboxConfFaxTemplate: Textbox;
    textboxContact: Textbox;
    textboxDefaultCallinScriptTempl: Textbox;
    textboxDefaultCounterRespTime: Textbox;
    textboxDefaultLoadSearch: Textbox;
    textboxDefaultSchedule: Textbox;
    textboxDefaultWaterfallRespTime: Textbox;
    textboxDeliveryReceipt: Textbox;
    textboxDeliveryWarning: Textbox;
    textboxDuplicateCarrierInvCheck: Textbox;
    textboxEnforceCarrierOos: Textbox;
    textboxEnforceHazmatExp: Textbox;
    textboxEnforceProhibitedCarriers: Textbox;
    textboxEqualToLess1: Textbox;
    textboxEqualToLess2: Textbox;
    textboxEqualToLess3: Textbox;
    textboxEqualToLess4: Textbox;
    textboxEqualToLess5: Textbox;
    textboxGreaterThan1: Textbox;
    textboxGreaterThan2: Textbox;
    textboxGreaterThan3: Textbox;
    textboxGreaterThan4: Textbox;
    textboxGreaterThan5: Textbox;
    textboxInsExpTemplateid: Textbox;
    textboxInsWarningDays: Textbox;
    textboxLevelWarningCarrierInv: Textbox;
    textboxLoadToRadius: Textbox;
    textboxLocationRadius: Textbox;
    textboxLockMinCarrierQual: Textbox;
    textboxLockMinNewCarrier: Textbox;
    textboxLockMinTargetMaxPay: Textbox;
    textboxMPactAPI: Textbox;
    textboxManuallyAddedStatus: Textbox;
    textboxMaxAssign: Textbox;
    textboxMaxHold: Textbox;
    textboxMaxLoadboard: Textbox;
    textboxMaxPayPercent: Textbox;
    textboxMaxRate: Textbox;
    textboxMaxUnassign: Textbox;
    textboxMaxUpdate: Textbox;
    textboxMaximumLoadsReturned: Textbox;
    textboxMinutesPriorToShipper: Textbox;
    textboxMpactHostURL: Textbox;
    textboxMpactKeyLastEntered: Textbox;
    textboxNotificationEmail: Textbox;
    textboxOfferContMoveDaysOut: Textbox;
    textboxOfferOrderFormat: Textbox;
    textboxOfferOrderFreeText: Textbox;
    textboxOfferOrderRadius: Textbox;
    textboxPickupWarning: Textbox;
    textboxRatingTriggerCode: Textbox;
    textboxRecurTractrCreateDays: Textbox;
    textboxServiceFailures: Textbox;
    textboxTargetPayCalc: Textbox;
    textboxTargetPayCalculation: Panel;
    textboxTargetProfit: Textbox;
    textboxWaterfallContMoveUser: Textbox;
    textboxWaterfallFreeText: Textbox;
    textboxWaterfallRadius: Textbox;
    textboxWaterfallTenderFormat: Textbox;
    textboxWebDefElecOffersRate: Textbox;
    textboxWebDefLoadboardPostRate: Textbox;
    textboxWtrfallContMoveDaysOut: Textbox;
}
